import React from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { getMatchDay, saveMatchDay } from "./../../services/matchDayService";

class MatchDayForm extends Form {
  state = {
    data: { id: -1, name: "" },
    errors: {}
  };

  schema = {
    id: Joi.number(),
    name: Joi.string().required()
  };

  async componentDidMount() {
    const { match, history } = this.props;

    const matchDayId = match.params.id;
    if (matchDayId === "new") return;

    const matchDay = await getMatchDay(matchDayId);
    if (!matchDay) return history.replace("/not-found");

    this.setState({ data: this.mapToViewModel(matchDay) });
  }

  mapToViewModel(matchDay) {
    return {
      id: matchDay.id,
      name: matchDay.name
    };
  }

  doSubmit = async () => {
    await saveMatchDay(this.state.data);
    this.props.history.push("/matchdays");
  };

  render() {
    return (
      <div>
        <h2>Match Day</h2>
        <form onSubmit={this.handleSubmit}>
          {this.renderLink(
            "/matchdays",
            "fa fa-arrow-left",
            "btn btn-secondary"
          )}
          {this.renderButton("fa fa-save", "btn btn-success m-1")}
          {this.renderInput("name", "Name", true)}
        </form>
      </div>
    );
  }
}

export default MatchDayForm;



// WEBPACK FOOTER //
// ./src/components/matchDays/matchDayForm.jsx